
import axios from 'axios';

const searchByContactIdUtil = async (token, contactId) => {

    let resData;
    var data = {
      "token": token,
      "contactId": contactId,
    };

    console.log('searchByContactId data sent to server: ' + JSON.stringify(data))
    
    const headers = { 
        'Content-Type': 'application/json'
    };

    // console.log(data);
    try {
        resData = await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/search-by-contactId', data, { headers })
        
    }catch(err) {
        console.log('searchByContactId: error received from Axios',err.message);
        throw new Error(err.message); 
    }
    console.log('searchByContactId results', JSON.stringify(resData))

    return resData;
    
};

export default searchByContactIdUtil